import React, { useState } from "react";
import { Table, Select } from "antd";
import { useSelector, RootStateOrAny, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getBrandBySlug } from "../../API/api";
import { setBrand } from "../../actions/actions";

interface Props {
  selectedBrands: any;
  setSelectedBrands: any;
}

export const ESG: React.FC<Props> = ({ selectedBrands, setSelectedBrands }: Props) => {
  const [activeTab, setActiveTab] = useState(0);
  const industryBrands = useSelector((state: RootStateOrAny) => state.industryBrands);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const goToBrand = (brandSlug: string) => {
    getBrandBySlug(brandSlug).then((slugBrand: any) => {
      if (slugBrand === undefined) {
        const notFoundBrand = {
          name: "Not found",
          url: true,
          description: "Search for an specific brand using the search field at the top",
          image: "",
          analytics: {
            webScore: 0,
          },
          competitors: [],
        };
        dispatch(setBrand(notFoundBrand));
      } else {
        dispatch(setBrand(slugBrand));
        navigate(`../brands/${brandSlug}`, { replace: true });
      }
    });
  };

  const columns: any = [
    {
      title: "Brand",
      dataIndex: "name",
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
      render: (text: any, record: any) => {
        return (
          <div style={{ display: "flex" }}>
            <div style={{ width: "64px", height: "64px", display: "flex", alignItems: "center" }}>
              {record.logo && (
                <img
                  src={record.logo}
                  alt={record.name}
                  style={{ width: "64px", maxWidth: "64px", maxHeight: "64px" }}
                />
              )}
            </div>
            <button
              type="button"
              onClick={() => goToBrand(record.slug)}
              className="tableNameButton"
            >
              {record.name}
            </button>
          </div>
        );
      },
    },
    {
      title: () => (
        <div style={{ display: "flex", gap: 10 }}>
          <span className="tableDropdownLabel">Choose Content Trends:</span>
          <Select
            defaultValue="asset-management"
            style={{ flex: 1, width: "100%" }}
            options={[
              {
                value: "asset-management",
                label: "Regulation/Reporting",
              },
              {
                value: "asset-management",
                label: "Inclusive Development",
              },
              {
                value: "asset-management",
                label: "Sustainable Investing",
              },
            ]}
          />
        </div>
      ),
      dataIndex: "name",
      render: () => {
        return (
          <div className="tableChart">
            <div className="value">XXX</div>
            <div className="chart" style={{ backgroundColor: "#E19C15", width: "75%" }} />
          </div>
        );
      },
    },
  ];

  const onSelectBrands = (selectedRows: any) => {
    setSelectedBrands(selectedRows);
  };

  const rowSelection: any = {
    selectedBrands,
    hideSelectAll: true,
    onChange: onSelectBrands,
    selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE],
  };

  return (
    <>
      <div className="tabs">
        <button
          className={activeTab === 0 ? "tabButton active" : "tabButton"}
          type="button"
          onClick={() => setActiveTab(0)}
        >
          Content trends
        </button>
        <button
          className={activeTab === 1 ? "tabButton active" : "tabButton"}
          type="button"
          onClick={() => setActiveTab(1)}
        >
          Asset class
        </button>
        <button
          className={activeTab === 2 ? "tabButton active" : "tabButton"}
          type="button"
          onClick={() => setActiveTab(2)}
        >
          ESG investing
        </button>
        <button
          className={activeTab === 3 ? "tabButton active" : "tabButton"}
          type="button"
          onClick={() => setActiveTab(3)}
        >
          Products + Services
        </button>
      </div>
      <div className="tabContent">
        <Table
          rowSelection={{
            type: "checkbox",
            ...rowSelection,
          }}
          dataSource={industryBrands}
          columns={columns}
          sortDirections={["descend", "ascend"]}
          pagination={{
            pageSize: 100,
            hideOnSinglePage: true,
            showSizeChanger: false,
          }}
        />
      </div>
    </>
  );
};
